import { checkedDevelopmentType } from './index'
import { apiFetch } from '../Utils/apiFetch'

/** Same path as Traccar / front-v3. Backend redirects to Keycloak, then `/?openid=success`. */
export const OPENID_AUTH_PATH = '/api/session/openid/auth'

/** Admin panel app key (same as password login). */
export const ADMIN_APP_KEY = '2bd5bd10345cd1555b14c221ec6e8647c46ee21e8ee45312'

const OPENID_ATTEMPT_KEY = 'flotilla-admin:openid-attempt'

export function markOpenIdAttempt () {
  try {
    sessionStorage.setItem(OPENID_ATTEMPT_KEY, new Date().toISOString())
  } catch (_) {
    /* ignore */
  }
}

export function startOpenIdLogin () {
  markOpenIdAttempt()
  window.location.href = OPENID_AUTH_PATH
}

/** GET /api/server → { openIdEnabled, openIdForce } */
export async function fetchOpenIdFlags () {
  try {
    const response = await apiFetch('/api/server', { method: 'GET' })
    if (!response.ok) return { openIdEnabled: false, openIdForce: false }
    const res = await response.json()
    const server = res && res.status === 'success' ? res.data : res
    if (!server || typeof server !== 'object') {
      return { openIdEnabled: false, openIdForce: false }
    }
    const openIdEnabled = Boolean(server.openIdEnabled)
    return {
      openIdEnabled,
      openIdForce: openIdEnabled && Boolean(server.openIdForce)
    }
  } catch (_) {
    return { openIdEnabled: false, openIdForce: false }
  }
}

/** GET /api/session with admin app key after OpenID cookie is set. */
export async function fetchOpenIdSession () {
  const fetchUrl = checkedDevelopmentType()
  const response = await apiFetch(
    `/api/session?app=${ADMIN_APP_KEY}${fetchUrl}`,
    { method: 'GET' }
  )
  if (!response.ok) {
    throw new Error('OpenID session not established')
  }
  const res = await response.json()
  if (res.status === 'success' && res.data && res.data.id) {
    return res.data
  }
  throw new Error(res.message || 'OpenID session not established')
}
